import { defineMessage } from 'services/localization';

export const messages = {
    text: defineMessage('the_final_total_amount__rwallex_account_manager'),
};
